import { Col, Row } from "antd"
import { FC } from "react"
import SelectDateSkeleton from "./SelectDate.skeleton"

type SelectDateFromToSkeletonProps = {
  size?: "small" | 'default'
}

const SelectDateFromToSkeleton: FC<SelectDateFromToSkeletonProps> = ({ size = 'default' }) => {

  return (
    <Row
      gutter={[15, 15]}
    >
      <Col
        span={12}
      >
        <SelectDateSkeleton size={size} />
      </Col>
      <Col span={12}>
        <SelectDateSkeleton
          size={size}
          isReturn
        />
      </Col>
    </Row>
  )
}

export default SelectDateFromToSkeleton